function paginate(array, pageSize, pageNumber) {
    const position = pageNumber - 1;
    return array.slice(position * pageSize, (position + 1) * pageSize);
}

module.exports = {
    paginate,
};
